module.exports = __webpack_public_path__ + "static/media/odometer-speed.8432522b.svg";